/* eslint-disable react/no-namespace */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/style-prop-object */
import React from 'react';

interface Props {
  id: string
  title?: string
}

const SvgSelector: React.FC<Props> = ({ id, title = undefined }) => {
  switch (id) {
    case 'notificationWarning':
      return (
        <svg width="20" height="20" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M31.6388 24.9219C32.6666 26.7344 31.3777 29 29.3275 29H2.67017C0.620033 29 -0.663386 26.7287 0.358905 24.9219L13.6876 1.35938C14.7154 -0.453125 17.2823 -0.453125 18.3101 1.35938L31.6388 24.9219ZM15.9988 20.0508C14.5876 20.0508 13.4431 21.2176 13.4431 22.6562C13.4431 24.0949 14.5876 25.2617 15.9988 25.2617C17.41 25.2617 18.5546 24.0949 18.5546 22.6562C18.5546 21.2176 17.41 20.0508 15.9988 20.0508ZM13.5709 10.6881L13.982 18.3912C13.9987 18.7537 14.2932 19.0312 14.6488 19.0312H17.3434C17.699 19.0312 17.9879 18.748 18.0101 18.3912L18.4212 10.6881C18.4435 10.2973 18.1379 9.96875 17.7545 9.62891H14.2321C13.8543 9.96875 13.5542 10.2973 13.5709 10.6881Z" fill="#FF9900" />
        </svg>

      );
    default:
      return null;
  }
};

export default SvgSelector;
